export const templates = [
  {
    id: 'privacy-notice',
    title: 'Section 5 Privacy Notice Template',
    audience: 'Every Data Fiduciary',
    description: 'An itemised, plain-language notice template covering the data collected, purpose of processing, and how to exercise rights and file complaints — structured for Section 5 compliance.',
    file: '/templates/privacy-notice.docx',
  },
  {
    id: 'consent-checklist',
    title: 'Consent Capture & Consent Manager Readiness Checklist',
    audience: 'Product & legal teams',
    description: 'A field-by-field checklist to audit sign-up and cookie-consent flows against Section 6\'s free, specific, informed, unconditional, unambiguous standard.',
    file: '/templates/consent-checklist.xlsx',
  },
  {
    id: 'dpia-template',
    title: 'Data Protection Impact Assessment (DPIA) Template',
    audience: 'Significant Data Fiduciaries',
    description: 'A structured DPIA workbook covering necessity, proportionality, risk identification and mitigation — aligned to Rule 13.',
    file: '/templates/dpia-template.docx',
  },
  {
    id: 'breach-response',
    title: 'Data Breach Response Playbook',
    audience: 'Security & compliance teams',
    description: 'A 72-hour breach response runbook with a Board notification template and a Data-Principal communication template, aligned to Rule 7.',
    file: '/templates/breach-response.docx',
  },
  {
    id: 'ropa-template',
    title: 'Record of Processing Activities (RoPA) Template',
    audience: 'DPOs & compliance leads',
    description: 'A ready-to-populate RoPA spreadsheet — processing activity, lawful basis, data categories, retention period and third-party sharing.',
    file: '/templates/ropa-template.docx',
  },
  {
    id: 'drp-response',
    title: 'Data Principal Rights Request Response Template',
    audience: 'Customer support & legal teams',
    description: 'Response templates for access, correction and erasure requests under Sections 11 and 12, mapped to Rule 14 timelines.',
    file: '/templates/drp-response.docx',
  },
];
